export const CustomerDetailsTab = {
  CONTACTS: 'CONTACTS',
  MAIN: 'MAIN',
  PROCESSES: 'PROCESSES',
  TASKS: 'TASKS',
} as const;

export type CustomerDetailsTab = (typeof CustomerDetailsTab)[keyof typeof CustomerDetailsTab];
